<template>
  <input-type-ahead
    :list="campuses"
    :value="value && value.id"
    :searchchange="getCampusesWithTimeout"
    :selected-value="selectCampus"
    placeholder="Search for a Campus..."
    label="Campus"
    option-value="id"
    option-text="name"
  />
</template>

<script>
import InputTypeAhead from '@/components/inputs/InputTypeAhead.vue';
import StudentClient from '@/api/StudentClient';
export default {
  components :{
    InputTypeAhead,
  },
  data() {
    return {
      studentClient: new StudentClient(this.$http),
      campusTimeout: null,
      campuses: [],
      campus: null,
    };
  },
  props: {
    value: {
      type: Object,
      require: false,
      default: () => null,
    },
    emailDomain: {
      type: String,
      require: false,
      default: () => null,
    }
  },
  async mounted() {
    try {
      await this.fetchAndSetCampuses(null, this.emailDomain);
    } catch (ex) {
      console.error(ex);
    }
  },
  methods:{
    getCampusesWithTimeout(query) {
      if (this.campusTimeout) {
        clearTimeout(this.campusTimeout);
        this.campusTimeout = null;
      }
      
      this.campusTimeout = setTimeout(async () => {
        if(!query)
          return;
        await this.fetchAndSetCampuses(query);
      }, 300);
    },
    async fetchAndSetCampuses(query, domain) {
      const response = await this.studentClient.campusSearch(query, domain);
      this.campus = null;
      this.campuses = response.campuses || [];
    },
    selectCampus(v) {
      this.$emit('input', this.campuses.find(x => x.id === v));
    },
  }
}
</script>

<style>

</style>